export const OBLIGATION_BY_LISTING = 'OBLIGATION_BY_LISTING';
export const OBLIGATION_TO_LISTING = 'OBLIGATION_TO_LISTING';
export const CLEAR_DEBTS_FILTER = 'CLEAR_DEBTS_FILTER';
export const CLEAR_DEBTS_FILTER_TO = 'CLEAR_DEBTS_FILTER_TO';
export const SET_FILTERS_OPTIONS_DEBTS = 'SET_FILTERS_OPTIONS_DEBTS';
export const SET_FILTERS_OPTIONS_DEBTS_TO = 'SET_FILTERS_OPTIONS_DEBTS_TO';
export const OBLIGATION_BY_ID = 'OBLIGATION_BY_ID';
